module.exports = __webpack_public_path__ + "static/media/kids_44.a9bdfb07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_44.jpg
// module id = 5900
// module chunks = 0